import clsx from "clsx";
import React from "react";

import styles from "./index.module.css";

interface ListProps {
  /** List theme */
  theme: "bullet" | "decimal" | "alpha";
  /** List theme */
  markerColor?: "inherit" | "base" | "muted";
  /** Additional class names */
  className?: string;
}

/**
 * Render a list.
 */
const List: React.FC<React.PropsWithChildren<ListProps>> = ({
  theme = "bullet",
  markerColor = "muted",
  className,
  children,
  ...rest
}) => {
  const classes = clsx(
    styles[theme],
    styles[markerColor],
    styles.listRoot,
    className
  );

  // Render ul for bullet theme, ol for decimal/alpha themes
  const Element = theme === "bullet" ? "ul" : "ol";

  return (
    <Element className={classes} {...rest}>
      {children}
    </Element>
  );
};

/**
 * Render a list item.
 */

interface ListItemProps {
  className?: string;
}

const ListItem: React.FC<React.PropsWithChildren<ListItemProps>> = ({
  className,
  children,
  ...rest
}) => {
  const classes = clsx(styles.listItemRoot, className);

  return (
    <li className={classes} {...rest}>
      {children} {/* Render children here */}
    </li>
  );
};

export { List, ListItem };
